import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';
import { Router } from '@angular/router';
import { ConfigurationService } from './configuration.service';
import { LoaderService } from './loader.service';

export interface RESPONSE {
  status: number;
  errorCode: string;
  Data: any;
  errorDescription: string;
}

@Injectable({
  providedIn: 'root',
})
export class ApiRequestsService {
  private token: string = '';
  private baseURL = '';
  // private baseURL = "http://192.168.0.183:3001/";

  public NO_ERROR = '000000';
  private currentUserSubject: BehaviorSubject<any>;
  public currentUser: Observable<any> | undefined;

  constructor(
    private config: ConfigurationService,
    private HttpClient: HttpClient,
    private route: Router,
    private loaderSer: LoaderService
  ) {
    this.baseURL = this.config.getBaseUrl();
    this.currentUserSubject = new BehaviorSubject(null);
    this.currentUser = this.currentUserSubject.asObservable();
  }



  generateHeaderForAPIRequest = () => {
    return new HttpHeaders({ 'authorization': 'Bearer ' + this.token, "authfor": "W", });
  }


  getApiCall = (url: string, params: any = null) => {
    let httpHeaders = this.generateHeaderForAPIRequest();
    let httpParams = new HttpParams();
    if (params)
      httpParams = httpParams.append("criteria", params);
    return this.HttpClient.get(this.baseURL + url, { params: httpParams, headers: httpHeaders });
  }

  postApiCall = (url: string, params: any, checkToken: boolean = true) => {
    const ele: any = document.getElementById('loader-div');
    if (ele)
      ele.style.display = "block";
    const body: any = {};
    if (!params['criteria']) body['criteria'] = params;
    else body['criteria'] = params['criteria'];
    let httpHeaders = this.generateHeaderForAPIRequest();
    return this.HttpClient.post(this.baseURL + url, body, { headers: httpHeaders }).pipe(map((data: any) => {
      if (ele)
        ele.style.display = "none";
      return data;
    }));
  }

  postApiCallReturningPromise = (url: string, body: object) => {
    return new Promise<RESPONSE>((resolve, reject) => {
      this.postApiCall(url, body).subscribe(res => {
        resolve(res);
      }, err => {
        reject(err);
      });
    });
  }

  getAPICallReturningPromise = (url: string, body: string) => {
    return new Promise<RESPONSE>((resolve, reject) => {
      this.getApiCall(url, body).subscribe(res => {
        resolve(res as RESPONSE);
      }, err => {
        reject(err);
      });
    });
  }

  updateOrSetTokenValue = (newToken: string) => {
    this.token = newToken;
  }
  public set Token(token: string) {
  }
  public get Token(): string {
    return this.token;
  }

  uploadMultiple(formData: FormData, endPoint: string) {
    const httpHeaders = new HttpHeaders({
      'authorization': 'Bearer ' + this.token,
      'authfor': 'W',
    });
    return this.HttpClient.post(this.baseURL + endPoint, formData, { headers: httpHeaders });
  }

  putFormData(endPoint: string, formData: FormData) {
    const httpHeaders = new HttpHeaders({
      'authorization': 'Bearer ' + this.token,
      'authfor': 'W',
    });
    return this.HttpClient.put(this.baseURL + endPoint, formData, { headers: httpHeaders });
  }

  putApiCall(endPoint: string, body: any) {
    const httpHeaders = this.generateHeaderForAPIRequest();
    return this.HttpClient.put(this.baseURL + endPoint, body, { headers: httpHeaders });
  }

  deleteApiCall(endPoint: string) {
    const httpHeaders = this.generateHeaderForAPIRequest();
    return this.HttpClient.delete(this.baseURL + endPoint, { headers: httpHeaders });
  }

  uploadFile(file: any, endPoint: string, criteria = {}) {
    const fd = new FormData();
    fd.append('criteria', JSON.stringify(criteria));
    fd.append('file', file, file.name);
    // console.log(fd);
    // console.log(file, file.name);
    let httpHeaders = new HttpHeaders({
      'authorization': 'Bearer ' + this.token,
      "authfor": "W"
    });
    httpHeaders.set('Content-type', 'multipart/form-data; boundary=1234567890xxxyyy104');
    return this.HttpClient.post(this.baseURL + endPoint, fd, { headers: httpHeaders });
  }

  getImageSRC(imageSrc: string, defaultSrc: string = ''): any {

    return this.baseURL + 'uploads/' + imageSrc ? imageSrc : defaultSrc
  }

  loginsignup(params: any) {
    if (!params['criteria']) params['criteria'] = params;
    return this.HttpClient.post(this.baseURL + "users/loginValidation", params)
  }

  logout() {
    this.route.navigateByUrl("/login");
    this.currentUserSubject.next(null);
    this.loaderSer.hideLoader();
  }

  _syncUser(data: any) {
    this.currentUserSubject.next(data);
  }
  public get currentUserValue(): any {
    return this.currentUserSubject.value;
  }
  public set currentUserValue(data: any) {
    this.currentUserSubject.next(data);
  }
}
